module.exports = __webpack_public_path__ + "static/media/1-12.6e703087.mp3";